import React, { useState, useEffect, createContext, useContext } from 'react';
import WPApiFetch from '../Utility/WPApi'
import queryString from 'query-string';
import { useHistory, useLocation } from 'react-router-dom';
export const FiltersContext = createContext();

export default function FiltersProvider({children}) {
	const [filters, setFilters] = useState(null);
	const [playlistFilters, setPlaylistFilters] = useState(null);
	const [activeFilters, setActiveFilters] = useState({filters:[]});
	const history = useHistory();
	const location = useLocation();

	const toggleParams = (key,value) => {
		const clone = activeFilters.filters;
		const inx = clone.findIndex((entry) => { return (entry.key === key && entry.value === value) })
		if(inx > -1) { 
			clone.splice(inx, 1);
		} else {
			clone.push({ key: key, value: value });
		}
		setActiveFilters({filters:clone});
	}
	const replaceParams = (key,value) => {
		const clone = activeFilters.filters;
		const exists = clone.findIndex((entry)=> { return entry.key === key; });
		if(exists > -1) { 
			clone[exists] = { key: key, value: value }
		} else { 
			clone.push({ key: key, value: value });
		}
		setActiveFilters({filters:clone});
	}
	const clearParams = (key = null) => {
		if(key) {
			const entries = activeFilters.filters.reduce((a,entry,inx)=> { 
				if(entry.key !== key) a.push(entry);
				return a;
			}, []);
			setActiveFilters({filters:entries});
		} else {
			setActiveFilters({filters:[]});
		}
	}

	useEffect(() => {
		const controller = new AbortController();
		async function fetchData() {
			try {
				const filtersData = await WPApiFetch('/r-flix/v1/filters', null, "GET", null, "omit", null, controller.signal);
				/*console.log(filtersData);
				
				
				const sorted = Object.entries(filtersData).forEach((entry)=> {
					
					console.log(entry[1]);


					if( typeof(entry[1] === 'object') ) {
						let objSorted = Object.entries(entry[1]);
							objSorted.sort((a,b)=> { return (a[1].name < b[1].name) ? -1 : (a[1].name > b[1].name) ? 1 : 0; });
						console.log(objSorted);
						//return [entry[0]
						
					}

				});
				console.log(sorted);
				*/

				setFilters(filtersData);
				const playlistFiltersData = await WPApiFetch('/r-flix/v1/playlist_filters', null, "GET", null, "omit", null, controller.signal);
				setPlaylistFilters(playlistFiltersData);
			} catch(e) {
				if (e.name === "AbortError") return;
				console.log(e);
			}
		}
		fetchData();
		return () => { controller.abort(); }
	},[]);

	useEffect(()=> {
		const parsed = queryString.parse(location.search, {arrayFormat: 'comma'});
		const active = [];
		Object.entries(parsed).forEach((entry,inx)=> {
			if(typeof(entry[1]) === 'object') {
				entry[1].forEach(item => {
					active.push( { key: entry[0], value: item } );
				});
			} else {
				active.push( { key: entry[0], value: entry[1] } );
			}
		});
		setActiveFilters({filters: active});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])


	useEffect(()=> {
		function parse() {
			//const parsed = queryString.parse(location.search, {arrayFormat: 'comma'});
			const parsed = {};
			const params = activeFilters.filters;

			params.forEach((entry)=> {
				if(entry.key === "orderby") {
					parsed[entry.key] = entry.value
				}
				else { 
					switch (typeof(parsed[entry.key])) {
						case "undefined": 
							parsed[entry.key] = entry.value;
							break
						case "string":
							if(parsed[entry.key] === entry.value) { 
								break;
							}
							parsed[entry.key]=[parsed[entry.key], entry.value]
							break
						case "object":
							if(parsed[entry.key].includes(entry.value)) { 
								parsed[entry.key].splice(parsed[entry.key].indexOf(params.value), 1);
								break;
							}
							parsed[entry.key].push(entry.value)
							break
						default: 
							break
					}
				}
			});
			const stringified = queryString.stringify(parsed, {arrayFormat: 'comma'});
			history.push(location.pathname+'?'+stringified);
		}
		activeFilters && parse();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	},[activeFilters]);
	
	const value = { filters, setFilters, playlistFilters, setPlaylistFilters, activeFilters, setActiveFilters, toggleParams, replaceParams, clearParams }
	return <FiltersContext.Provider value={value}>{children}</FiltersContext.Provider>
}

export function useFilters() {
	const context = useContext(FiltersContext);
	if (context === undefined) {
		throw new Error("Context must be used within a Provider");
	}
	return context;
}